export default __webpack_public_path__ + "static/media/therapy_center.f7385f3a.png";